import * as z from 'zod';

import { emailSchema } from '@/_schemas/generic';

export const resetPasswordFormSchema = z
  .object({
    token: z.string().min(1, 'Reset token is required'),
    email: emailSchema(false),
    password: z.string().min(8, 'Password must be at least 8 characters'),
    password_confirmation: z.string().min(1, 'Please confirm your password'),
  })
  .refine((data) => data.password === data.password_confirmation, {
    message: 'Passwords do not match',
    path: ['password_confirmation'],
  });

export type ResetPasswordFormSchema = z.infer<typeof resetPasswordFormSchema>;

export const resetPasswordSearchSchema = z.object({
  token: z.string().catch(''),
  email: z.string().catch(''),
});

export type ResetPasswordSearchSchema = z.infer<typeof resetPasswordSearchSchema>;
